module.exports = __webpack_public_path__ + "img/logo_01.1e08d028.png";